class TimerService {
  constructor(interval = 1000, scale = 1000) {
    this.interval = interval;
    this.scale = scale;
    this.elapsed = 0;
  }

  tick() {
    this.elapsed += (this.interval / this.scale);
  }

  start() {
    this.timer = setInterval(this.tick.bind(this), this.interval);
    return this;
  }

  stop() {
    if(this.timer) {
      clearInterval(this.timer);
    }
    return this;
  }

  clear() {
    this.elapsed = 0;
    if(this.timer) {
      clearInterval(this.timer);
    }
    return this;
  }
}

module.exports = TimerService;
